import { AppLayout } from "@bcc/components/app-layout";
import { AnalyticsView } from "@bcc/components/views/analytics-view";

export function AnalyticsPage() {
  const revenueData = [
    { month: "January", revenue: 24500 },
    { month: "February", revenue: 28900 },
    { month: "March", revenue: 32100 },
    { month: "April", revenue: 29800 },
    { month: "May", revenue: 35600 },
    { month: "June", revenue: 38200 },
  ];

  const salesData = [
    { month: "January", orders: 145 },
    { month: "February", orders: 168 },
    { month: "March", orders: 189 },
    { month: "April", orders: 172 },
    { month: "May", orders: 205 },
    { month: "June", orders: 218 },
  ];

  const topProductsData = [
    { product: "Premium Coffee Blend", sales: 1250 },
    { product: "Single Origin Ethiopia", sales: 890 },
    { product: "French Roast Beans", sales: 750 },
    { product: "Light Roast Sampler", sales: 625 },
    { product: "Espresso Dark Roast", sales: 480 },
  ];

  return (
    <AppLayout>
      <AnalyticsView revenueData={revenueData} salesData={salesData} topProductsData={topProductsData} />
    </AppLayout>
  );
}
